import { Injectable } from '@angular/core';
import { BroadcastMessage } from './broadcast-message.interface';

@Injectable({ providedIn: 'root' })
export class TabSyncService {
  private channel = new BroadcastChannel('tab-sync');

  broadcastMessage(message: BroadcastMessage) {
    this.channel.postMessage(message);
  }

  getChannel(): BroadcastChannel {
    return this.channel;
  }
}
